export type UserSignInEvent = {
    event: 'club_login';
    user_id: string;
    confirmed_user: boolean;
};

export const trackUserSignInEvent = (userId: string, verified: boolean = false): UserSignInEvent => ({
    event: 'club_login',
    user_id: userId,
    confirmed_user: verified
});
